import React from 'react';

import * as styles from './PartnerMiniModuleSkeleton.styles';

export const PARTNER_MINI_MODULE_SKELETON_TEST_ID = 'PartnerMiniModule-skeleton';

/**
 * Loading placeholder shown while the partner content and insights requests are
 * in flight. Mirrors the module's layout so the swap to real content does not
 * shift the surrounding page.
 */
export const PartnerMiniModuleSkeleton = () => (
  <div aria-hidden css={styles.root} data-testid={PARTNER_MINI_MODULE_SKELETON_TEST_ID}>
    <div css={styles.detailsRow}>
      <span css={styles.logo} />
      <span css={styles.textColumn}>
        <span css={styles.lineWide} />
        <span css={styles.lineNarrow} />
      </span>
    </div>
    <div css={styles.infoStrip}>
      <span css={styles.infoItem} />
      <span css={styles.infoItem} />
      <span css={styles.infoItem} />
    </div>
  </div>
);
